<template>
	<UserRegistrationLayout>
		<div class="slot-title mb-2">Welcome!</div>
		<p>{{ requestCodeText }}</p>
		<v-form @submit.prevent="submitForm" v-model="isFormValid" class="user-input-box mt-6 width-100" ref="form">
			<SignupTextField
				label="Email"
				iconName="email"
				:rules="emailRules"
				v-model="email"
				type="email"
				autofocus
				single-line
				placeholder="your@email.com"
			/>
			<AnemicButton :disabled="!this.isFormValid" type="submit" class="continue-button width-100 my-4">Next</AnemicButton>
		</v-form>
	</UserRegistrationLayout>
</template>

<script>
import UserRegistrationLayout from '@/views/userRegistration/UserRegistrationLayout';
import SignupTextField from '@/views/userRegistration/components/SignupTextField';
import UserRegistrationMixin from '@/views/userRegistration/helpers/UserRegistrationMixin';
import UserRegistrationService from '@/views/userRegistration/helpers/UserRegistrationService';

export default {
	name: 'PortalAuthRequestCode',
	props: { requestCodeText: { type: String, required: true } },
	mixins: [UserRegistrationMixin],
	components: {
		SignupTextField,
		UserRegistrationLayout,
	},
	methods: {
		submitForm() {
			this.$refs.form.validate();
			if (this.isFormValid) {
				this.$emit('email-submitted', this.email);
			}
		},
	},
	async mounted() {},
	data() {
		return {
			email: '',
			isFormValid: false,
			requiredRules: UserRegistrationService.getRequiredRules(),
			emailRules: UserRegistrationService.getEmailValidationRules(),
		};
	},
};
</script>

<style scoped lang="scss">
.continue-button {
	height: 45px;
	padding: 0px;
	font-size: 14px !important;
	color: white;
	background: var(--bold-border-color) !important;
	border: 1px solid var(--bold-border-color);
}
</style>
